import React from "react";
import { CheckCircle2, Circle, XCircle } from "lucide-react";

const getOptionText = (option) =>
  typeof option === "string" ? option : option.options;

const isCorrectOption = (option) =>
  typeof option === "string" ? false : option.correct === 1;

const MCQQuestion = ({
  question,
  options,
  onOptionSelect = () => {},
  selectedOption,
  submitted,
}) => {
  const handleOptionChange = (event) => {
    onOptionSelect(event.target.value);
  };

  return (
    <section className="rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="mb-4">
        <p className="text-sm font-semibold uppercase text-purple-700">
          Question
        </p>
        <h2 className="mt-1 text-lg font-extrabold leading-7 text-gray-900">
          {question}
        </h2>
      </div>

      <div className="space-y-3">
        {Array.isArray(options) ? (
          options.map((option, index) => {
            const optionText = getOptionText(option);
            const isCorrect = isCorrectOption(option);

            return (
              <label
                key={`${optionText}-${index}`}
                htmlFor={`option${index}`}
                className={`flex cursor-pointer items-start gap-3 rounded-md border p-4 transition ${
                  submitted
                    ? selectedOption === optionText
                      ? isCorrect
                        ? "border-green-200 bg-green-50 text-green-800"
                        : "border-red-200 bg-red-50 text-red-800"
                      : isCorrect
                      ? "border-green-200 bg-green-50 text-green-800"
                      : "border-slate-200 bg-slate-50 text-gray-600"
                    : selectedOption === optionText
                    ? "border-purple-300 bg-purple-50 text-purple-900 ring-2 ring-purple-100"
                    : "border-slate-200 bg-white text-gray-700 hover:border-purple-200 hover:bg-purple-50/60"
                }`}
              >
                <input
                  type="radio"
                  id={`option${index}`}
                  name="mcqOption"
                  value={optionText}
                  checked={selectedOption === optionText}
                  onChange={handleOptionChange}
                  className="mt-1 h-4 w-4 border-slate-300 text-purple-700 focus:ring-purple-500"
                  disabled={submitted}
                />
                <span className="flex-1 text-sm font-semibold leading-6">
                  {optionText}
                </span>
                {submitted &&
                  selectedOption === optionText &&
                  (isCorrect ? (
                    <CheckCircle2
                      className="mt-0.5 h-5 w-5 shrink-0 text-green-600"
                      aria-hidden="true"
                    />
                  ) : (
                    <XCircle
                      className="mt-0.5 h-5 w-5 shrink-0 text-red-600"
                      aria-hidden="true"
                    />
                  ))}
                {!submitted && selectedOption !== optionText && (
                  <Circle
                    className="mt-0.5 h-5 w-5 shrink-0 text-slate-300"
                    aria-hidden="true"
                  />
                )}
              </label>
            );
          })
        ) : (
          <p className="rounded-md bg-slate-50 p-4 text-sm text-gray-500">
            No options available.
          </p>
        )}
      </div>
    </section>
  );
};

export default MCQQuestion;
